"use strict";

exports.__esModule = true;
exports.Tooltip = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTippy = require("react-tippy");

require("react-tippy/dist/tippy.css");

var _utils = require("../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Tooltip = function Tooltip(props) {
  var width = props.width,
      className = props.className,
      children = props.children,
      content = props.content,
      size = props.size,
      otherProps = _objectWithoutPropertiesLoose(props, ["width", "className", "children", "content", "size"]);

  var tooltipClass = (0, _classnames["default"])('br-4 ta-left elevation-3', {
    'py-1 px-2 fs-1': size === 'sm',
    'py-3 px-4': size === 'md'
  }, className);
  return _react["default"].createElement(_reactTippy.Tooltip, _extends({}, otherProps, {
    size: size,
    arrowSize: size === 'sm' ? 'small' : 'regular',
    html: _react["default"].createElement("div", {
      className: tooltipClass,
      style: {
        maxWidth: (0, _utils.normalizeSize)(width)
      }
    }, content)
  }), children);
};

exports.Tooltip = Tooltip;
Tooltip.propTypes = {
  width: _propTypes["default"].number,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  content: _propTypes["default"].node,
  size: _propTypes["default"].oneOf(['sm', 'md'])
};
Tooltip.defaultProps = {
  size: 'md',
  width: '100%',
  content: '',
  children: '',
  className: ''
};